module.exports = "---\nurl: \"https://gist.githubusercontent.com/MartinChang0723/3cd916e86018e2a24eb73dac225828b9/raw/d0939bd1ce82a77468588a99999d7766781ec9da/evo-ip.yaml\"\ndom_id: \"#swagger-ui\"\nvalidatorUrl: \"https://online.swagger.io/validator\"\noauth2RedirectUrl: \"http://localhost:3200/oauth2-redirect.html\"\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 1019
// module chunks = 0